import React, { useState, useEffect } from 'react';
import PlayingCard from '../components/PlayingCard';
import { TYPES, TYPE_COLORS, TYPE_CARD } from '../data/types';
import './EmailCapture.css';

export default function EmailCapture({ result, tracking, cookieConsent, onSubmit }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  const mbtiCode = result ? result.split('-')[0] : 'INFP';
  const atCode   = result ? (result.split('-')[1] || 'A') : 'A';
  const data = TYPES[mbtiCode] || TYPES['INFP'];
  const card = TYPE_CARD[mbtiCode];
  

  const handleSubmit = async () => {
    if (!email.includes('@') || !email.includes('.')) {
      setError('Bitte gib eine gültige E-Mail-Adresse ein.');
      return;
    }
    setLoading(true); setError('');
    try {
      await fetch('/api/save_result.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, type: mbtiCode, at_type: atCode, cid: tracking?.cid || '', uid: tracking?.uid || '', consent_cookies: cookieConsent === true, consent_email: true, consent_ts: new Date().toISOString(), tz: Intl.DateTimeFormat().resolvedOptions().timeZone, lang: navigator.language }),
      });
    } catch (e) {}
    setTimeout(() => { setLoading(false); onSubmit(email); }, 700);
  };

  const skip = () => onSubmit('');

  return (
    <div className="capture-page" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s' }}>
      <nav className="test-nav" style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 48px',height:64,background:'#fff',borderBottom:'1px solid var(--border)'}}>
        <span style={{fontFamily:'Nunito,sans-serif',fontSize:20,fontWeight:900,letterSpacing:'-0.03em'}}>
          <span style={{color:'var(--teal)'}}>ICH</span><span style={{color:'var(--text)'}}>TYPE</span><span style={{fontSize:11,fontWeight:700,color:'var(--text3)',marginLeft:1}}>.DE</span>
        </span>
      </nav>

      <main className="capture-main">
        <div className="capture-card">

          {/* Card preview — already revealed! */}
          <div className="capture-card-preview">
            <PlayingCard typeCode={mbtiCode} size="large" />
          </div>

          {/* Teaser text */}
          <div className="capture-teaser">
            <div className="capture-type-code" style={{color:'var(--teal)'}}>{mbtiCode}-{atCode}</div>
            <h2 className="capture-title">{data.name}</h2>
            <div className="capture-card-label">
              {card.rankName} {card.suitName} · {data.percent} der Bevölkerung
            </div>
          </div>

          <div className="capture-divider">
            <span>Vollständigen Bericht per E-Mail erhalten</span>
          </div>

          {/* Email form */}
          <div className="capture-form">
            <input type="email" className="email-input" placeholder="deine@email.de"
              value={email} onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSubmit()} autoFocus />
            <button className="btn-unlock" onClick={handleSubmit} disabled={loading}>
              {loading
                ? <span className="loading-dots"><span/><span/><span/></span>
                : '📬 Bericht kostenlos erhalten'}
            </button>
            {error && <p className="capture-error">{error}</p>}
          </div>

          <p className="capture-legal">Deine E-Mail wird vertraulich behandelt. Kein Spam. Abmeldung jederzeit möglich.</p>

          {/* Skip option */}
          <button className="skip-btn" onClick={skip}>
            Weiter ohne E-Mail →
          </button>
        </div>
      </main>
    </div>
  );
}
